import { siteData } from "../data/mock";
import { MapPin, Clock, Instagram, MessageCircle, Phone } from "lucide-react";

export const LocationSection = () => {
  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            Localização e Contato
          </h2>
          <p className="text-lg text-slate-500">
            Venha nos visitar ou entre em contato
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {/* Info */}
          <div className="space-y-6">
            {/* Address Card */}
            <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-100">
              <div
                className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgba(133, 188, 255, 0.15)' }}
              >
                <MapPin size={20} style={{ color: '#85BCFF' }} />
              </div>
              <div>
                <h3 className="text-sm font-bold text-slate-900 mb-1">Endereço</h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {siteData.contact.address.building}, {siteData.contact.address.suite}
                  <br />
                  {siteData.contact.address.street}
                  <br />
                  {siteData.contact.address.city}, {siteData.contact.address.zip}
                </p>
              </div>
            </div>

            {/* Hours Card */}
            <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-100">
              <div
                className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgba(133, 188, 255, 0.15)' }}
              >
                <Clock size={20} style={{ color: '#85BCFF' }} />
              </div>
              <div>
                <h3 className="text-sm font-bold text-slate-900 mb-1">Horário de Atendimento</h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {siteData.contact.hours.weekdays}
                  <br />
                  {siteData.contact.hours.weekends}
                </p>
              </div>
            </div>

            {/* Contact Card */}
            <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-100">
              <div
                className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgba(133, 188, 255, 0.15)' }}
              >
                <Phone size={20} style={{ color: '#85BCFF' }} />
              </div>
              <div>
                <h3 className="text-sm font-bold text-slate-900 mb-1">Contato</h3>
                <p className="text-sm text-slate-600">(49) 98887-1661</p>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3 pt-2">
              <a
                href={siteData.brand.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 rounded-lg text-sm font-bold transition-all duration-200 hover:scale-105"
                style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
              >
                <MessageCircle size={16} />
                WhatsApp
              </a>
              <a
                href={siteData.brand.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 rounded-lg text-sm font-bold border-2 border-slate-200 text-slate-700 transition-all duration-200 hover:border-[#85BCFF] hover:scale-105"
              >
                <Instagram size={16} />
                Instagram
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden h-[420px] shadow-lg border border-slate-200">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.8!2d-52.6344!3d-27.0964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94e4b5e5c5c5c5c5%3A0x0!2sAv.%20Porto%20Alegre%2C%20427%20-%20Centro%2C%20Chapec%C3%B3%20-%20SC%2C%2089802-130!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização da Clínica"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
